import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  chatQuestions : [],
  chatQuestion : null,
  error : null
};


export const CHAT_QUESTION_URL = "/admin/user/chat-question";

export const createChatQuestion = createAsyncThunk(
    CHAT_QUESTION_URL + "/post",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(CHAT_QUESTION_URL, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data || "Error"
        );
      }
    }
);

export const getChatQuestion = createAsyncThunk(
  CHAT_QUESTION_URL + "/get",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(CHAT_QUESTION_URL);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const getChatQuestionById = createAsyncThunk(
  CHAT_QUESTION_URL + "/get-chat-question",
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(CHAT_QUESTION_URL + "-by-id/" + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const deleteChatQuestion = createAsyncThunk(
  CHAT_QUESTION_URL + '/delete',
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      // const id = formData.get('id')
      const response = await axiosInstance.delete(CHAT_QUESTION_URL + '/' + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const chatQuestionSlice = createSlice({
    name : "chatQuestion",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(createChatQuestion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createChatQuestion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.chatQuestion = action.payload;
            })
            .addCase(createChatQuestion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getChatQuestionById.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getChatQuestionById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.chatQuestion = action.payload;
            })
            .addCase(getChatQuestionById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getChatQuestion.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getChatQuestion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.chatQuestions = action.payload;
            })
            .addCase(getChatQuestion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(deleteChatQuestion.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(deleteChatQuestion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.chatQuestion = action.payload;
            })
            .addCase(deleteChatQuestion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default chatQuestionSlice.reducer